import { css } from "styled-components"
import * as colors from "@livesession/design-system-colors"

// TODO: styled-components theme provider

const themeValues = {
  primaryColor: "#0446ca",
  primaryBorderColor: "#1561d1",
  defaultColor: "#20283b",
  darkColor: "#000",
  outlineDarkColor: "#404040",
  ghostColor: "#576871", // old "#678",
  smokedWhite: "#A7A7A7",
  disabledColor: "#bfbfbf",
  disabledHoverColor: "#dfdfe2",
  primaryContraColor: "#FFE478",
  warningColor: "#D6204C",

  primaryBackgroundColor: "#1f273a",
  defaultBackgroundColor: "#f1f3f5",
  ghostBackgroundColor: "#f8f9fa",

  modalShadeColor: "#122c5d5c",

  borderColor: "#dbe1e2", // "#d9d9d9",
  lightBorderColor: "#f0f2f4",

  inputTextColor: "#000",

  inputBorderColor: "#ebebeb", // "#d9d9d9",
  inputBackgroundColor: "#fafbfb",

  // TODO: upper colors should be replaced with below colors

  colors: colors,

  fontSize: {
    xsmall: "10.4px",
    small: "12px",
    normal: "13px",
    large: "14px",
    xlarge: "18px",
    xxlarge: "24px",
    xxxlarge: "28.8px",
  },

  inputSize: {
    large: "42px",
    medium: "36px",
    small: "28px",
  },

  iconSize: {
    xlarge: "24px",
    large: "20px",
    medium: "16px",
    small: "14px",
    xsmall: "12px",
  },
}

const mixins = {
  ellipsis: css`
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
    `,

  rounded: css`
        border-radius: 4px;
    `,

  shadow: css`
        box-shadow: 0 1px 2px 0 rgba(0,0,0,.3);
    `,

  mainShadow: css`
        // box-shadow: 0 0 0 1px rgba(0,0,0,.05), 0 4px 7px 2px rgba(0,0,0,.05);
    `,

  boxShadow: css`
        box-shadow: 0 0 15px rgb(0 0 0 / 6%);
    `,

  inputShadow: css`
        box-shadow: 0 6px 8px rgba(102,119,136,.03), 0 1px 2px rgba(102,119,136,.3);
    `,

  primaryTextColor: css`
        color: ${themeValues.primaryColor};
    `,

  defaultTextColor: css`
        color: ${themeValues.defaultColor};
    `,

  ghostTextColor: css`
        color: ${themeValues.ghostColor};
    `,

  centerFlex: css`
        display: flex;
        align-items: center;
        justify-content: center;
    `,

  disabledInput: css`
        opacity: 0.75;
        background-color: #f0f3f6;
    `,

  focusedInput: css`
        border-color: #aaa;
        outline: 0;
    `,

  staticWidth: (width: number) => css`
        width: ${width};
        flex-basis: ${width};
        min-width: ${width};
        max-width: ${width};
    `,
}

const sizes = {
  desktop: 992,
  tablet: 768,
  phone: 576,
}

const mediaQuery = (size: number) => (styles: string) =>
  css`
        @media (max-width: ${size}px) {
            ${styles}
        }
    `

const media = {
  desktop: mediaQuery(sizes.desktop),
  tablet: mediaQuery(sizes.tablet),
  phone: mediaQuery(sizes.phone),
}

export { themeValues, mixins, media, sizes }
